import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { MODEL_WEARS_STORES } from "../../constants";
import { parseModelWearsContent } from "../../utils/parseModelWearsContent";
import styles from "./ModelWears.scss";

function shouldShowModelWears(storeCode?: string): boolean {
  return storeCode ? MODEL_WEARS_STORES.includes(storeCode) : false;
}

export default function ModelWears() {
  const { productDescription, storeCode } = (useRuntimeConstants() || {}) as {
    productDescription?: { sizeAndFit?: string };
    storeCode?: string;
  };

  const { sizeAndFit } = productDescription || {};

  if (!shouldShowModelWears(storeCode) || !sizeAndFit?.trim()) {
    return null;
  }

  const parsedContent = parseModelWearsContent(sizeAndFit);

  if (!parsedContent) {
    return null;
  }

  return (
    <div
      className={styles.modelWears}
      data-testid="model-wears"
      dangerouslySetInnerHTML={{ __html: parsedContent }}
    />
  );
}
